/**
 * @file 执行动态脚本，目前用于随心搭画布需求
 */
let promise: Promise<any> | null = null;
let whiteList: string[] | null = null;

const DYNAMIC_SCRIPT = 'https://ops-wps.bj.bcebos.com/rlkb-extension/dynamic-script.js';

// 加载动态执行的脚本
export const loadDynamicScript = () => {
    if (promise === null) {
        promise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.async = true;
            script.type = 'module';
            script.onload = () => {
                const module = (window as any)._wikiDynamicScriptModule; // 假设脚本会将模块挂载到window对象上
                resolve(module || {});
            };
            script.onerror = err => {
                reject(err);
            };
            script.src = DYNAMIC_SCRIPT;
            document.head.appendChild(script);
        });
    }
    return promise;
};

// 加载可执行的白名单
export const loadWhiteList = async () => {
    if (whiteList === null) {
        const fetchWhiteList = await fetch('https://ops-wps.bj.bcebos.com/rlkb-extension/dyn_script_white')
            .then(res => res.text())
            .then(res => res.split('\n').filter(Boolean));
        whiteList = fetchWhiteList?.length > 0 ? fetchWhiteList : [];
    }
    return whiteList;
};

// 提前加载脚本
loadDynamicScript();
